import { Box, Grid, Image } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import React, { FC, memo } from "react";
import CropPickerInput from "../../../components/ImageCropPicker/CropPickerInput";

interface IContactUsPage {
  form: UseFormReturnType<TPagesContent>;
}

const ContactUsPage: FC<IContactUsPage> = ({ form }) => {
  return (
    <Box my={20}>
      <Grid>
        <Grid.Col lg={12}>
          {form.values?.contactUs?.heroBanner && (
            <Image
              src={
                typeof form.values?.contactUs?.heroBanner === "string"
                  ? form.values?.contactUs?.heroBanner
                  : URL.createObjectURL(form.values?.contactUs?.heroBanner)
              }
              my={10}
            />
          )}
          <CropPickerInput
            name={"contactUs.heroBanner"}
            label="Hero Banner (ratio: 113 × 40)"
            formHandler={form}
            pickerRatio={113 / 40}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default memo(ContactUsPage);
